module.exports = __webpack_public_path__ + "assets/img/IMG607.72bf3412.jpg";